import { jwtDecode } from 'jwt-decode';

const decryptData = (text: string): string => {
  const symbolToLetter: Record<string, string> = {
    '!': 'a',
    '@': 'B',
    '#': 'c',
    $: 'D',
    '%': 'e',
    '^': 'F',
    '&': 'g',
    '?': 'i',
    '+': 'J',
    '=': 'k',
    '|': 'L',
    '~': 'm',
    '/': 'N',
    '-': 'o',
    _: 'P',
    '{': 'q',
    '}': 'R',
    '[': 's',
    ']': 'T',
    '(': 'U',
    ')': 'v',
    '<': 'W',
    '>': 'x',
    ':': 'Y',
    ';': 'z',
    '*': '.',
  };

  let result = '';

  for (let i = 0; i < text?.length; i++) {
    const char = text[i];
    result += symbolToLetter[char] || char;
  }

  return result;
};

export const getSessionData = () => {
  const storedToken = localStorage.getItem('token');
  if (!storedToken) return null;

  try {
    const originalToken = decryptData(storedToken);

    const decoded: any = jwtDecode(originalToken);
    const userType = String(decoded['emis_usertype']);

    const STATE_TYPES = ['5', '21', '52'];
    const DISTRICT_TYPES = ['9', '10', '37', '38', '36', '19', '13'];
    const BLOCK_TYPES = ['39', '6'];

    let user_role_level = '';
    if (STATE_TYPES.includes(userType)) {
      user_role_level = 'state';
    } else if (DISTRICT_TYPES.includes(userType)) {
      user_role_level = 'district';
    } else if (BLOCK_TYPES.includes(userType)) {
      user_role_level = 'block';
    }
    return {
      schoolName: decoded['school_name'],
      cate_id: decoded['cate_id'],
      manage_id: decoded['manage_id'],
      schoolId: decoded['school_id'],
      schoolKeyId: decoded['school_key_id'],
      edu_dist_name: decoded['edu_dist_name'],
      userId: decoded['emis_user_id'],
      username: decoded['emis_username'],
      edn_dist_name: decoded['edn_dist_name'],
      usertype: decoded['user_type'],
      usertypeid: decoded['emis_usertype'],
      emisUsertype1: decoded['emis_usertype1'],
      schoolTypeId: decoded['school_type_id'],
      lowClass: decoded['low_class'],
      highClass: decoded['high_class'],
      districtId: decoded['district_id'],
      districtName: decoded['district_name'],
      blockId: decoded['block_id'],
      blockName: decoded['block_name'],
      cateType: decoded['cate_type'],
      teacherType: decoded['teacher_type'],
      teacherId: decoded['teacher_id'],
      catty_id: decoded['catty_id'],
      mod2: decoded['mod2'],
      teacher_name: decoded['teacher_name'],
      name: decoded['name'],
      designation: decoded['designation'],
      type_teacher: decoded['type_teacher'],
      emis_username: decoded['emis_username'],
      subject_id: decoded['subject_id'],
      Socialname: decoded['Socialname'],
      switch_login: decoded['swith_login'],
      switch_designation: decoded['switch_designation'],
      phnumber: decoded['mbl_nmbr'],
      email: decoded['email'],
      category_type: decoded['category_type'],
      authToken: originalToken,
      user_role_level: user_role_level,
    };
  } catch (error) {
    console.error('Token Decode Error:', error);
    return null;
  }
};
